import { apiClient } from './client'

export interface Brand {
  id: string
  factory: string
  productType: string | null
  brand: string
  website: string | null
  createdById: string | null
  createdAt: string
}

export async function getBrands(): Promise<Brand[]> {
  const res = await apiClient.get<{ success: true; data: Brand[] }>('/brands')
  return res.data.data
}

export async function createBrand(data: {
  factory: string
  productType?: string | null
  brand: string
  website?: string | null
}): Promise<Brand> {
  const res = await apiClient.post<{ success: true; data: Brand }>('/brands', data)
  return res.data.data
}

export async function updateBrand(
  id: string,
  data: {
    factory?: string
    productType?: string | null
    brand?: string
    website?: string | null
  },
): Promise<Brand> {
  const res = await apiClient.patch<{ success: true; data: Brand }>(`/brands/${id}`, data)
  return res.data.data
}

export async function deleteBrand(id: string): Promise<void> {
  await apiClient.delete(`/brands/${id}`)
}

export async function importBrands(
  rows: { factory: string; productType?: string | null; website?: string | null }[],
): Promise<{ inserted: number; skipped: number }> {
  const res = await apiClient.post<{ success: true; data: { inserted: number; skipped: number } }>(
    '/brands/import',
    rows,
  )
  return res.data.data
}
